export interface iAudioEffectExperiencePropsType {
  dataId: string;
  appId?: string;
  meetingJoinUrl: string;
  onErrorMessage?: (data: any) => void;
  onStopRecordBefore?: () => void;
  onStopRecord?: () => void;
  postAgentRequest: (params: any) => void;
  meetingState: any;
  updateMeetingState: any;
  checkMicPerm?: boolean; // 是否检查麦克风权限
  dataAutologs?: {
    paused: string;
    continue: string;
    end: string;
  };
}

export enum eAudioEffectExperience {
  SINGLE_SENTENCE = "SINGLE_SENTENCE",
  COMPLETE = "COMPLETE",
}

export enum eControlsGroup {
  PAUSE = "PAUSE",
  CONTINUE = "CONTINUE",
  END = "END",
}
